var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdown2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60522 7.21026C3.60522 5.21918 5.21931 3.6051 7.21038 3.6051H21.631C23.6221 3.6051 25.2361 5.21918 25.2361 7.21026V21.6309C25.2361 23.6219 23.6221 25.236 21.631 25.236H7.21038C5.21931 25.236 3.60522 23.6219 3.60522 21.6309V7.21026Z",
    fill: "#3448FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69095 15.181C7.69095 14.451 8.28278 13.8591 9.01284 13.8591C9.7429 13.8591 10.3347 14.451 10.3347 15.181V19.5473C10.3347 20.2773 9.7429 20.8692 9.01284 20.8692C8.28278 20.8692 7.69095 20.2773 7.69095 19.5473V15.181Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0987 17.1843C13.0987 16.4542 13.6905 15.8624 14.4206 15.8624C15.1506 15.8624 15.7425 16.4542 15.7425 17.1843V19.5477C15.7425 20.2777 15.1506 20.8695 14.4206 20.8695C13.6905 20.8695 13.0987 20.2777 13.0987 19.5477V17.1843Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5064 9.97397C18.5064 9.24391 19.0982 8.65208 19.8283 8.65208C20.5584 8.65208 21.1502 9.24391 21.1502 9.97397V19.5477C21.1502 20.2777 20.5584 20.8695 19.8283 20.8695C19.0982 20.8695 18.5064 20.2777 18.5064 19.5477V9.97397Z",
    fill: "url(#paint0_linear_1668_2974)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1668_2974",
    x1: 14.4207,
    y1: 3.6051,
    x2: 14.4207,
    y2: 25.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D18BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdown2);
export default __webpack_public_path__ + "static/media/icon-dropdown2.bb7cfb12fa7b02ddcda9b7a29390c809.svg";
export { ForwardRef as ReactComponent };